import { createAsyncThunk, createAction } from '@reduxjs/toolkit';

import { removeCookie, deleteAccessToken } from '@backrs_ui/common-ui';

import { ENVIRONMENT } from '@backrs_ui/grow-ui/src/settings';

import { PostHog } from 'posthog-js';

/** listen to this one in the store */
export const logout = createAction('auth/logout');

/** dispatch this thunk from components (the page shell) */
export const logoutThunk = createAsyncThunk(
  'auth/logoutThunk',
  async ({ postHog }: { postHog: PostHog }, { dispatch }) => {
    // first delete the access token
    deleteAccessToken('backrs_ui_token');

    // then remove the cookie
    removeCookie(ENVIRONMENT);

    // then dispatch the logout action
    dispatch(logout());

    postHog.capture('logout');
    postHog.reset();
  },
);
